import React from "react";
import Footer from "./Footer";
import Navigation from "./Navigation";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
require("../assets/css/bootstrap-utilities.css");
require("../assets/css/sgi.css");

const Layout = ({ children }: any) => {
  return (
    <>
      <header className="bg-tlc">
        <div className="container">
          <div className="d-flex p-2">
            <div className="ms-5">
              <a href="https://www.transelec.cl/">
                <img src="/logoTranselecWhite.svg" alt="logoTraselec" className="logoTLC" />
              </a>
            </div>
            <div className="energia">
              <img src={require("../assets/img/conectarLasEnergiasDelFuturo.png")} className="logoEnergia" />
            </div>
          </div>
        </div>
      </header>
      <div className="container-fluid">
        <Navigation />
        <main>{children}</main>
        <Footer />
      </div>
    </>
  );
};

export default Layout;
